<template>
    <client-page>
        <template #subHead>
            <sub-visual sh="태성 이혼가사변호사" tabActive="문종하 변호사 소개" bg="/images/sub/visual/sv-about.jpg" />
        </template>
        <page-section tit="문종하 변호사 소개" titAdd="법무법인 태성" class="lawyer-view__head" titClass="pb-0">
            <template #pageSectionImmersive>
                <v-img src="/images/sub/taesung/lawyer/lawyer-bg.svg" max-width="1840" :aspect-ratio="1840 / 266" class="text-bg w-100" />
            </template>
        </page-section>
        <page-section class="lawyer-view__body secondary">
            <v-row>
                <v-col cols="12" sm="7">
                    <lawyer-moon-head />
                </v-col>
                <v-col cols="8" sm="5" offset="4" offset-sm="7" offset-md="0">
                    <div class="lawyer-img-wrap">
                        <v-img data-aos="fade-left" src="/images/lawyer/view/문종하.png" max-width="586" :aspect-ratio="586 / 900" class="lawyer-img w-100" />
                    </div>
                </v-col>
            </v-row>
        </page-section>
        <page-section class="lawyer-view__foot page-section--last page-section--sm">
            <info-row v-for="(info, index) in lawyer?.MoonJongha?.info" :key="index" :title="info.title" :topLine="index == 0">
                <template v-if="info.text">
                    {{ info.text }}
                </template>
                <info-detail v-for="(detail, index) in info.infoDetail" :key="index" :class="index !== 0 ? 'mt-10px mt-md-16px' : ''">
                    <span v-if="typeof detail === 'string'">{{ detail }}</span>
                    <strong v-else-if="detail.bold">{{ detail.txt }}</strong>
                </info-detail>
            </info-row>
        </page-section>
    </client-page>
</template>

<script>
import { lawyer } from "@/assets/data/lawyer.js";

import ClientPage from "@/sets/styles/apps/client-page.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/sets/styles/pages/page-section.vue";
import InfoRow from "@/sets/styles/info-row.vue";
import InfoDetail from "@/sets/styles/info-detail.vue";

import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";
import LawyerMoonHead from "@/components/client/sub/taesung/lawyer-moon-head.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        InfoRow,
        InfoDetail,

        Tit,
        Txt,
        LawyerMoonHead,
    },
    data() {
        return {
            lawyer,
        };
    },
};
</script>

<style lang="scss" scoped>
</style>
